var _circle, _circle2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _path, _path2, _path3, _line14, _line15, _line16, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGatherTimeResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 422,
    height: 360,
    viewBox: "0 0 422 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 213.699,
    cy: 205.74,
    r: 85.2603,
    fill: "#D9D9D9",
    fillOpacity: 0.3,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 213.699,
    cy: 205.74,
    r: 78.9954,
    fill: "#D9D9D9",
    fillOpacity: 0.3,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 215.699,
    y1: 132.352,
    x2: 215.699,
    y2: 146.224,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 178.936,
    y1: 141.368,
    x2: 185.872,
    y2: 153.382,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 149.155,
    y1: 240.702,
    x2: 161.169,
    y2: 233.766,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 175.273,
    y1: 268.308,
    x2: 182.209,
    y2: 256.295,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 151.155,
    y1: 167.314,
    x2: 163.169,
    y2: 174.25,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 140.311,
    y1: 203.74,
    x2: 154.183,
    y2: 203.74,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 215.699,
    y1: 265.256,
    x2: 215.699,
    y2: 279.128,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 245.389,
    y1: 256.466,
    x2: 252.325,
    y2: 268.48,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 264.254,
    y1: 174.25,
    x2: 276.267,
    y2: 167.314,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 241.725,
    y1: 153.21,
    x2: 248.661,
    y2: 141.196,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 266.254,
    y1: 233.766,
    x2: 278.267,
    y2: 240.702,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 273.215,
    y1: 203.74,
    x2: 287.087,
    y2: 203.74,
    stroke: "#FFF761",
    strokeWidth: 4
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 301,
    y1: 204.5,
    x2: 335,
    y2: 204.5,
    stroke: "#FFF761",
    strokeWidth: 3,
    strokeDasharray: "6 6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M354.04 214.12H347.824L345.04 212.512V209.08H348.4V211.24H353.464V206.752H349.264V203.872H353.464V199.96H348.4V202.12H345.04V198.688L347.824 197.08H354.04L356.824 198.688V204.088L354.736 205.288V205.336L356.824 206.536V212.512L354.04 214.12ZM371.646 202.8L375.646 214H373.438L372.59 211.584H368.398L367.55 214H365.342L369.342 202.8H371.646ZM370.478 205.616L369.07 209.664H371.902L370.51 205.616H370.478ZM386.667 214V206.608H386.635L384.107 214H381.979L379.435 206.512H379.403V214H377.243V202.8H380.219L383.035 211.04H383.067L385.867 202.8H388.827V214H386.667ZM390.58 214.32L394.356 202.48H396.436L392.66 214.32H390.58ZM398.196 214V202.8H404.1L405.956 203.872V208.864L404.1 209.936H400.436V214H398.196ZM400.436 204.72V208.016H403.716V204.72H400.436ZM417.62 214V206.608H417.588L415.06 214H412.932L410.388 206.512H410.356V214H408.196V202.8H411.172L413.988 211.04H414.02L416.82 202.8H419.78V214H417.62Z",
    fill: "#FFF761"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M211.533 336.96V341.784L213.237 340.8H216.789L219.573 342.408V349.512L216.789 351.12H210.957L208.173 349.512V335.688L210.957 334.08H216.789L219.573 335.688V339.12H216.213V336.96H211.533ZM211.533 343.68V348.24H216.213V343.68H211.533ZM234.38 339.8L238.38 351H236.172L235.324 348.584H231.132L230.284 351H228.076L232.076 339.8H234.38ZM233.212 342.616L231.804 346.664H234.636L233.244 342.616H233.212ZM249.401 351V343.608H249.369L246.841 351H244.713L242.169 343.512H242.137V351H239.977V339.8H242.953L245.769 348.04H245.801L248.601 339.8H251.561V351H249.401ZM253.314 351.32L257.09 339.48H259.17L255.394 351.32H253.314ZM260.93 351V339.8H266.834L268.69 340.872V345.864L266.834 346.936H263.17V351H260.93ZM263.17 341.72V345.016H266.45V341.72H263.17ZM280.354 351V343.608H280.322L277.794 351H275.666L273.122 343.512H273.09V351H270.93V339.8H273.906L276.722 348.04H276.754L279.554 339.8H282.514V351H280.354Z",
    fill: "#FFF761"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2128 211.24V206.416L8.50881 207.4H4.95681L2.17281 205.792V198.688L4.95681 197.08H10.7888L13.5728 198.688V212.512L10.7888 214.12H4.95681L2.17281 212.512V209.08H5.53281V211.24H10.2128ZM10.2128 204.52V199.96H5.53281V204.52H10.2128ZM28.3799 202.8L32.3799 214H30.1719L29.3239 211.584H25.1319L24.2839 214H22.0759L26.0759 202.8H28.3799ZM27.2119 205.616L25.8039 209.664H28.6359L27.2439 205.616H27.2119ZM43.4012 214V206.608H43.3692L40.8412 214H38.7132L36.1692 206.512H36.1372V214H33.9772V202.8H36.9532L39.7692 211.04H39.8012L42.6012 202.8H45.5612V214H43.4012ZM47.3141 214.32L51.0901 202.48H53.1701L49.3941 214.32H47.3141ZM54.9303 214V202.8H60.8343L62.6903 203.872V208.864L60.8343 209.936H57.1703V214H54.9303ZM57.1703 204.72V208.016H60.4503V204.72H57.1703ZM74.3543 214V206.608H74.3223L71.7943 214H69.6663L67.1223 206.512H67.0903V214H64.9303V202.8H67.9063L70.7223 211.04H70.7543L73.5543 202.8H76.5143V214H74.3543Z",
    fill: "#FFF761"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 212.5,
    y1: 97,
    x2: 212.5,
    y2: 64,
    stroke: "#FFF761",
    strokeWidth: 3,
    strokeDasharray: "6 6"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 215.5,
    y1: 287,
    x2: 215.5,
    y2: 327,
    stroke: "#FFF761",
    strokeWidth: 3,
    strokeDasharray: "6 6"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 126,
    y1: 204.5,
    x2: 86,
    y2: 204.5,
    stroke: "#FFF761",
    strokeWidth: 3,
    strokeDasharray: "6 6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M219.43 53.512L216.646 55.12H210.094L207.31 53.512V39.688L210.094 38.08H216.646L219.43 39.688V53.512ZM210.67 40.96V52.24H216.07V40.96H210.67ZM234.243 43.8L238.243 55H236.035L235.187 52.584H230.995L230.147 55H227.939L231.939 43.8H234.243ZM233.075 46.616L231.667 50.664H234.499L233.107 46.616H233.075ZM249.264 55V47.608H249.232L246.704 55H244.576L242.032 47.512H242V55H239.84V43.8H242.816L245.632 52.04H245.664L248.464 43.8H251.424V55H249.264ZM253.177 55.32L256.953 43.48H259.033L255.257 55.32H253.177ZM260.794 55V43.8H266.698L268.554 44.872V49.864L266.698 50.936H263.034V55H260.794ZM263.034 45.72V49.016H266.314V45.72H263.034ZM280.218 55V47.608H280.186L277.658 55H275.53L272.986 47.512H272.954V55H270.794V43.8H273.77L276.586 52.04H276.618L279.418 43.8H282.378V55H280.218Z",
    fill: "#FFF761"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatherTimeResult);
export default __webpack_public_path__ + "static/media/gatherTimeResult.e290ad2d2b4139ee39bf4c3a06ec91d1.svg";
export { ForwardRef as ReactComponent };